import React from "react";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import {
  Document,
  Font,
  Page,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import iransans from "../../../../assets/fonts/vazir/Farsi-Digits-Without-Latin/Vazir-FD-WOL.ttf";
import { nameVariables } from "../CarContractItems";
import momentJalai from "moment-jalaali";
import TextPdfFix from "../../../UI/TextPdfFix";

function formatCurrency(n, currency) {
  return (
    currency +
    n.toFixed(0).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    })
  );
}

const CarContractSalePrint = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { data } = props;

  return (
    <Wrapper>
      <Button variant={"outlined"} onClick={(e) => setOpenModal(true)}>
        چاپ خرید
      </Button>
      <Dialog
        open={openModal}
        onClose={(e) => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <PDFDownloadLink
            document={
              <CarCOntractPdfGenerator data={data} title={"فرم معامله ماشین"} />
            }
            fileName="download_pdf.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "در حال آماده سازی فایل ..." : "دانلود نمایید!"
            }
          </PDFDownloadLink>
        </DialogContent>
      </Dialog>
    </Wrapper>
  );
};

const Table = ({ children }) => (
  <View
    style={{
      marginTop: 8,
      marginBottom: 8,
      // borderTop: "1 solid black",
      // borderLeft: "1 solid black",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </View>
);

const TableRow = ({ style, children }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      ...style,
    }}
  >
    {children}
  </View>
);

const TableCell = ({ style, children }) => (
  <View
    style={{
      flex: 1,
      // borderRight: "1 solid black",
      // borderBottom: "1 solid black",
      paddingRight: 3,
      paddingTop: 3,
      paddingBottom: 3,
      textAlign: "right",
      direction: "ltr",
      ...style,
    }}
  >
    <Text>{children}</Text>
  </View>
);

const CarCOntractPdfGenerator = (props) => {
  Font.register({
    family: "IRANSans",
    src: iransans,
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontFamily: "IRANSans",
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      textAlign: "right",
    },
    cellHeader: {
      fontSize: 8,
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
    },
  });

  let deliver_item = JSON.parse(props.data.delivered_items);

  const showItems = (item) => {
    return item ? <Text style={{ color: "green" }}>دارد</Text> : "-";
  };

  return (
    <Document
      file="somefile.pdf"
      onLoadSuccess={(e) => {}}
    >
      <Page size="A4" style={styles.body}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <View>
            <View>
              <Text>
                خ{props.data.document_number}
                شماره سند :
              </Text>
            </View>
            <View>
              <Text>
                {props.data.document_date_fa}
                تاریخ سند :
              </Text>
            </View>
          </View>
          <View style={{ width: 300, textAlign: "center", direction: "rtl" }}>
            <Text>به نام خدا</Text>
            <Text>قرارداد واگذاری</Text>

            <Text></Text>
          </View>

          <View
            style={{
              paddingTop: 5,
              textAlign: "right",
              fontSize: 13,
              width: 100,
            }}
          >
            <Text>بنگاه فریدونی</Text>
          </View>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>فروشنده</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_number}
                شماره شناسنامه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.lastname} {props.data.Seller.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Seller.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>خریدار</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_number}
                شماره شناسنامه :{" "}
              </TableCell>

              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.lastname} {props.data.Buyer.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Buyer.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>
        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>مورد واگذاری</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.manufacture_date}
                سال ساخت :{" "}
              </TableCell>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.car_color}
                رنگ :
              </TableCell>
              <TableCell style={{ border: "none", flex: "auto", width: "290" }}>
                {props.data.car_type}
                یک دستگاه خودروی سواری :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.chassis_number}
                شماره شاسی :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.vin_number}: VIN شماره
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.motor_number}
                شماره موتور :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.current_tag}
                پلاک اتتظامی شماره :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.remained
                  ? formatCurrency(props.data.remained, "")
                  : 0}
                {" : "} الباقی ثمن معامله{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.prepayment
                  ? formatCurrency(props.data.prepayment, "")
                  : ""}
                {" : "} پیش پرداخت
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.price ? formatCurrency(props.data.price, "") : ""}
                {" : "} کل ثمن معامله
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                فقره چک به شرح پشت این قرارداد توسط خریدار به فروشنده پرداخت
                گردید.
                {props.data.cheques ?? 0}
                می باشد که طی
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                چنانچه مشخص شود مورد واگذاری مشخصاتش اعم از رنگ شدگی و تغییر
                کیلومتر کارکرد با آنچه طبق اظهارات فروشنده زمان عقد
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 1
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                قرارداد تطابق ندارد، وی موظف است ظرف مدت یک روز عین ثمن معامله
                را به علاوه 01 درصد ارزش کل قرارداد که به عنوان حق فسخ{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                س محسوب شده بپردازد و چنانچه در این پرداخت تعلل کند بابت هر روز
                دیر کرد نیم‌درصد جمع کل ثمن معامله به علاوه 01 درصد ارزش کل
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>قرارداد را بابت خسارت تاخیر تادیه بپردازد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                فروشنده متعهد می‌گردد کلیه مفاصا حساب های دولتی و شخصی نسبت به
                این خودرو اعم از عدم خلافی راهنمایی و رانندگی و{" "}
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 2
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                عوارض شهرداری و مالیات دارایی و یا بدهی به شرکت سازنده یا لیزینگ
                را تا قبل از تسویه حساب و دریافت ثمن معامله به خریدار ارائه دهد.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                کلیه هزینه های نقل و انتقال سند به صورت قطعی بدین ترتیب که اول
                یک وکالت کاری کامل جهت تعویض پلاک بدون تاریخ انقضا
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 3
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                توسط فروشنده به خریدار یا هر شخصی که از طرف خریدار معرفی گردد
                اعطاء می گردد و بعد از تعویض پلاک سند به صورت قطعی نقل و{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                انتقال پیدا خواهد کرد که به عهده فروشنده می باشد.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                با توجه به اینکه کلیه مسئولیت پلاک نصبی بر روی خودرو که متعلق به
                فروشنده می باشد از این لحظه به بعد به عهده خریدار است
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 4
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                ال لذا محدودیت زمانی برای فک پلاک در نظر گرفته نمی‌شود.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                با توجه به نوسانات لحظه ای قیمت کلیه خیارات حتی خیار غبن و تدلیس
                از فروشنده ساقط گردید.
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 5
              </TableCell>
            </TableRow>

            <TableRow style={{ paddingTop: 20 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View>
          <Table>
            <TableRow>
              <TableCell>
                این قرارداد و عین 6 بند مندرج در آن در حضور شاهدین ذیل این
                قرارداد که حضورشان مورد تایید است در نهایت صحت و سلامت
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 6
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                عقل و جسم و با آگاهی کامل از عوارض ناشی از آن و بدون هیچ اجبار و
                تردید با دقت مطالعه و تفهیم و مورد تایید قرار گرفت.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                با کلیه متعلقات و
                {momentJalai(props.data.delivery_date)
                  .format("jDD-jMM-jYYYY")
                  .split("")
                  .reverse()
                  .join("")}
                {"  "}
                {momentJalai(props.data.delivery_date)
                  .format("HH:mm")
                  .split("")
                  .reverse()
                  .join("")}
                خودرو مذکور راس ساعت
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.key_card)}: {nameVariables.key_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.spare_key)}: {nameVariables.spare_key}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.body_insurance)}:{" "}
                {nameVariables.body_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.third_party_insurance)}:{" "}
                {nameVariables.third_party_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.id_card)}: {nameVariables.id_card}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.technical_inspection)}:{" "}
                {nameVariables.technical_inspection}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.mayoralty_charges)}:{" "}
                {nameVariables.mayoralty_charges}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.fuel_card)}: {nameVariables.fuel_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.golden_card)}:{" "}
                {nameVariables.golden_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.garranty_card)}:{" "}
                {nameVariables.garranty_card}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                توسط فروشنده به خریدار تحویل گردید.
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("jDD-jMM-jYYYY")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("HH:mm")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                تاریخ
                {"  "}
                {props.data.inspection_center}
                {"  "}و تاییدیه کارشناسی مرکز
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>شرایط پرداخت</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextPdfFix text={props.data.payment_terms} />
              </TableCell>
            </TableRow>
            <TableRow style={{ paddingTop: 50 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>
          </Table>
        </View>
      </Page>
    </Document>
  );
};
export default CarContractSalePrint;
